import { StrictMode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { accountRouter } from "./routes";
import { AuthProvider } from "@/components/layouts/AuthProvider";
import { ThemeSync } from "@/app/lib/theme/ThemeSync";
import { I18nProvider } from "@/app/lib/i18n";

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Root of the standalone account (auth) app — its own router/route tree,
 * AuthLayout chrome only (no product dashboard). Owns login, register,
 * password reset, Google OAuth callback, user-setup, and accept-invite.
 * Product apps (pro-web, certification-web) bounce here for auth and return
 * via the shared cookie + pending redirect allowlist.
 */
export function AccountApp() {
  return (
    <StrictMode>
      <QueryClientProvider client={qc}>
        <ThemeSync />
        <AuthProvider>
          <I18nProvider>
            <RouterProvider router={accountRouter} />
          </I18nProvider>
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}
